import type { ReactNode } from "react"

interface KerangkaAuthProps {
  judul: string
  deskripsi?: string
  children: ReactNode
  kaki?: ReactNode
}

export function KerangkaAuth({ judul, deskripsi, children, kaki }: KerangkaAuthProps) {
  return (
    <div className="min-h-dvh bg-background">
      <header className="relative overflow-hidden rounded-b-[2.5rem] bg-gradient-to-br from-primary via-primary to-primary-emphasis px-6 pb-20 pt-[max(2rem,env(safe-area-inset-top))] text-primary-foreground">
        <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-white/10 blur-2xl" />
        <div aria-hidden="true" className="pointer-events-none absolute -left-10 bottom-0 h-40 w-40 rounded-full bg-black/10 blur-2xl" />
        <div className="relative mx-auto max-w-md">
          <img src="/icon/nobg.png" alt="PterokuDesu" className="h-10 w-10 rounded-xl bg-white/15 p-1.5" />
          <h1 className="mt-6 font-display text-3xl font-semibold leading-tight">{judul}</h1>
          {deskripsi && <p className="mt-1.5 max-w-xs text-sm text-primary-foreground/85">{deskripsi}</p>}
        </div>
      </header>

      <main className="mx-auto -mt-12 max-w-md px-4 pb-10">
        <div className="space-y-5 rounded-3xl border border-border bg-card p-5 shadow-xl shadow-black/5 sm:p-6">{children}</div>
        {kaki && <div className="mt-5 text-center text-sm text-muted-foreground">{kaki}</div>}
      </main>
    </div>
  )
}

export function PemisahAtau() {
  return (
    <div className="flex items-center gap-3 text-xs text-muted-foreground" role="separator">
      <span className="h-px flex-1 bg-border" />
      atau
      <span className="h-px flex-1 bg-border" />
    </div>
  )
}
